import api from './api';

/**
 * Track a click event for analytics
 * @param {string} eventId - The event ID
 * @param {string} elementType - Type of element (speaker, gallery, agenda, sponsor, ticket, video, location)
 * @param {string} elementId - Optional specific element ID
 * @param {string} elementName - Optional readable name for the element
 */
export const trackClick = async (eventId, elementType, elementId = null, elementName = null) => {
  if (!eventId || !elementType) return;
  
  try {
    await api.post('/analytics/track', {
      event_id: eventId,
      event_type: elementType,  // Backend expects 'event_type', not 'element_type'
      element_id: elementId,
      target_url: elementName   // Backend uses 'target_url' for element name
    });
  } catch (error) {
    // Silently fail - analytics should not break the user experience
    console.debug('Analytics tracking failed:', error);
  }
};

/**
 * Create a click handler that tracks and then executes the original action
 * @param {string} eventId - The event ID
 * @param {string} elementType - Type of element
 * @param {string} elementId - Optional element ID
 * @param {string} elementName - Optional element name
 * @param {function} originalHandler - Optional original click handler
 */
export const createTrackedClickHandler = (eventId, elementType, elementId = null, elementName = null, originalHandler = null) => {
  return (e) => {
    trackClick(eventId, elementType, elementId, elementName);
    if (originalHandler) {
      originalHandler(e);
    }
  };
};

export default trackClick;
